import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconSubtract = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-subtract' + (className ? ` ${className}` : '')}
            fill='none'
            height='2'
            viewBox='0 0 10 2'
            width='10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0.542083 1.08333C0.3925 1.08333 0.264792 1.03181 0.158958 0.92875C0.0529862 0.825694 0 0.698056 0 0.545834C0 0.393472 0.0519447 0.264444 0.155834 0.15875C0.259584 0.0529166 0.388194 0 0.541667 0H8.95792C9.1075 0 9.23521 0.0515281 9.34104 0.154584C9.44701 0.257639 9.5 0.385278 9.5 0.5375C9.5 0.689861 9.44806 0.818889 9.34417 0.924583C9.24042 1.03042 9.11181 1.08333 8.95833 1.08333H0.542083Z'
                fill={fill} />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconSubtract;
